import type { Resource } from '../../';
export const country_countries_HR: Resource = {"default":"Croatia"};
